/**
 * Displays invitation status with colored dot and translated text.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { InvitationStatus } from '../../../../../types/orders';

import './style.scss';

interface StatusIndicatorProps {
  status: InvitationStatus;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  const { t } = useTranslation();

  const statusText = t(`mijn_vnl.orders.status.${status}`);

  const classes = classNames('StatusIndicator', {
    'StatusIndicator--invited': status === 'invited',
    'StatusIndicator--started': status === 'started',
    'StatusIndicator--finished': status === 'finished',
  });

  return (
    <div className={classes}>
      <span className="StatusIndicator__dot" />
      <span className="StatusIndicator__text">{statusText}</span>
    </div>
  );
};

export default StatusIndicator;
